import React from 'react';
import { FacebookIcon, InstagramIcon, TwitterIcon, LinkedinIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-gray-900 text-white" data-id="element-161">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-162">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-163">
          <div className="space-y-4" data-id="element-164">
            <div className="flex items-center" data-id="element-165">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mGHYUh8bFRbFqAvk8BmDot/pasted-image-Photoroom.png" alt="日本清掃センター" className="h-24 w-auto object-contain" data-id="element-166" />
            </div>
            <p className="text-gray-600" data-id="element-167">
              全国主要都市で高品質な清掃サービスを提供しています。
            </p>
            <div className="flex space-x-4" data-id="element-168">
              <a href="#" className="text-gray-400 hover:text-gray-500" data-id="element-169">
                <TwitterIcon className="h-6 w-6" data-id="element-170" />
              </a>
              <a href="#" className="text-gray-400 hover:text-gray-500" data-id="element-171">
                <FacebookIcon className="h-6 w-6" data-id="element-172" />
              </a>
              <a href="#" className="text-gray-400 hover:text-gray-500" data-id="element-173">
                <InstagramIcon className="h-6 w-6" data-id="element-174" />
              </a>
            </div>
          </div>
          <div data-id="element-175">
            <h3 className="text-sm font-semibold text-gray-900 uppercase mb-4" data-id="element-176">
              サービス
            </h3>
            <ul className="space-y-2" data-id="element-177">
              <li data-id="element-178">
                <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-179">
                  ホテル清掃
                </a>
              </li>
              <li data-id="element-180">
                <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-181">
                  民泊施設清掃
                </a>
              </li>
              <li data-id="element-182">
                <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-183">
                  オフィス清掃
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-184">
            <h3 className="text-sm font-semibold text-gray-900 uppercase mb-4" data-id="element-185">
              会社情報
            </h3>
            <ul className="space-y-2" data-id="element-186">
              <li data-id="element-187">
                <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-188">
                  会社概要
                </a>
              </li>
              <li data-id="element-189">
                <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-190">
                  採用情報
                </a>
              </li>
              <li data-id="element-191">
                <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-192">
                  プライバシーポリシー
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-193">
            <h3 className="text-sm font-semibold text-gray-900 uppercase mb-4" data-id="element-194">
              お問い合わせ
            </h3>
            <ul className="space-y-2" data-id="element-195">
              <li className="text-gray-600" data-id="element-196">
                <MapPinIcon className="h-5 w-5 inline-block mr-2" data-id="element-197" />
                東京都世田谷区用賀4丁目34-12
              </li>
              <li className="text-gray-600" data-id="element-198">
                <PhoneIcon className="h-5 w-5 inline-block mr-2" data-id="element-199" />
                080-7886-2747
              </li>
              <li className="text-gray-600" data-id="element-200">
                <MailIcon className="h-5 w-5 inline-block mr-2" data-id="element-201" />
                nipponseisoucenter@aol.com
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-8 mt-12 text-center" data-id="element-202">
          <p className="text-gray-600 text-sm" data-id="element-203">
            © 2024 日本清掃センター. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;